export default class Footer {
    constructor() {
        // Footer

        this.credits();
        this.promos();
    }

    credits() {
        const popin = document.querySelector('.credits__popin');
        const link = document.querySelector('.footer__lien--credits');

        if (popin && link) {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                popin.classList.add('js-open');
            });

            popin.querySelector('.credits__popinClose').addEventListener('click', (event) => {
                event.preventDefault();
                popin.classList.remove('js-open');
            });

            popin.querySelector('.credits__popinOverlay').addEventListener('click', (event) => {
                event.preventDefault();
                popin.classList.remove('js-open');
            });
        }
    }

    promos() {
        const popin = document.querySelector('.promos__popin');
        
        if (popin) {
            if (sessionStorage.getItem('promos') !== 'true') {
                setTimeout(() => {
                    popin.classList.add('js-open');
                    sessionStorage.setItem('promos', 'true');
                }, 2000);
            }

            popin.querySelector('.promos__popinClose').addEventListener('click', (event) => {
                event.preventDefault();
                popin.classList.remove('js-open');
            });

            popin.querySelector('.promos__popinOverlay').addEventListener('click', (event) => {
                event.preventDefault();
                popin.classList.remove('js-open');
            });
        }
    }
}